<template>
	<div>
		<div v-if="isTested" class="test-modal-header flex-centerize" :class="{ 'test-failed': isError, 'test-passed': !isError }">
			<IconError v-if="isError" />
			<IconSuccess v-else />
			<div>{{ isError ? 'Test Failed' : 'Test Successful' }}</div>
			<AppCloseX class="close-icon" @onClose="$emit('onClose')" />
		</div>
		<div v-else class="test-modal-header flex-centerize">Test Your widget</div>

		<div class="test-modal-body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import IconError from '../FlowTreeBlock/assets/icon-x.svg';
import IconSuccess from '../FlowTreeBlock/assets/icon-vi.svg';

export default {
	name: 'TestResultModal',
	components: {
		IconSuccess,
		IconError,
	},
	props: {
		isError: { type: Boolean },
		isTested: { type: Boolean, default: true },
	},
	computed: {},
	methods: {},
};
</script>

<style scoped lang="scss">
@mixin header-layout($bg-color, $color) {
	background-color: $bg-color;
	color: $color;

	svg {
		margin-right: 10px;

		circle {
			stroke: $color;
		}
		path {
			fill: $color;
		}
	}
}

.test-modal-header {
	position: relative;
	padding: 10px;
	font-weight: 600;
	background-color: rgb(239, 243, 246);

	&.test-passed {
		@include header-layout(#59c4a1, white);
	}
	&.test-failed {
		@include header-layout(#f5d2d5, #e95d65);
	}

	.close-icon {
		position: absolute;
		top: 50%;
		right: 12px;
		transform: translate(0, -50%);
	}
}

.test-modal-body {
	max-height: 67vh;
	margin: 10px;
	margin-bottom: 0px;
	padding-bottom: 20px;
	overflow: auto;

	.description {
		margin: 10px;
	}
}
</style>
